module.exports = __webpack_public_path__ + "img/audio.f0b36d0c.svg";